import { render, staticRenderFns } from "./CantCreate.vue?vue&type=template&id=0cd3e734&"
import script from "./CantCreate.vue?vue&type=script&lang=js&"
export * from "./CantCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports